<template>
  <div class="app">
    <AppHeader
      :user="$store.state.user"
      @mobileMenuToggle="showMobileMenu = !showMobileMenu"
    />

    <b-container
      fluid
      tag="main"
      class="app-body"
    >
      <RouterView class="layout-full__content" />
    </b-container>

    <AppFooter />
  </div>
</template>

<script>
import { Header as AppHeader, Footer as AppFooter } from "@/components/";

export default {
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style lang="scss">
.layout-full {
  &__content {
    flex-grow: 1;
  }
}
</style>
